import { render, staticRenderFns } from "./FormItemComponent.vue?vue&type=template&id=ac5f2ca8&scoped=true&"
import script from "./FormItemComponent.vue?vue&type=script&lang=js&"
export * from "./FormItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f2ca8",
  null
  
)

export default component.exports